import {Injectable} from '@angular/core';
import {catchError, map, Observable, of} from 'rxjs';

import {FirestoreWrapperService} from "../../../../../core/services/firestore-wrapper.service";
import {MEMBER_TYPE} from "../../../setting/common/service/employer-account/member/member.service";
import {TAB_TYPE} from "../../model/user.model";
import {ORGANIZATION_COLLECTION} from "../../constant/firestore-collection.constant";
import {
    DEFAULT_VISIBLE_TABS_BY_MEMBER_TYPE,
    FALLBACK_VISIBLE_TABS,
    ROLE_BASE_ACCESS_SUB_COLLECTION
} from "../../constant/role-base-access.constant";

@Injectable({
    providedIn: 'root'
})
export class RoleBaseAccessFirestoreService {

    constructor(private firestoreWrapperService: FirestoreWrapperService) {
    }

    findVisibleTabs(organizationId: string, memberType: MEMBER_TYPE): Observable<TAB_TYPE[]> {
        const defaultVisibleTabs: TAB_TYPE[] = this.resolveDefaultVisibleTabs(memberType);
        if (!organizationId || !memberType) {
            return of(defaultVisibleTabs);
        }
        return this.firestoreWrapperService
            .get<RoleBaseAccessOutDto>(this.buildCollectionPath(organizationId), memberType)
            .pipe(
                map((roleBaseAccessOutDto: RoleBaseAccessOutDto) =>
                    this.mapToVisibleTabs(roleBaseAccessOutDto, defaultVisibleTabs)),
                catchError(() => of(defaultVisibleTabs))
            );
    }

    resolveDefaultVisibleTabs(memberType: MEMBER_TYPE): TAB_TYPE[] {
        return DEFAULT_VISIBLE_TABS_BY_MEMBER_TYPE[memberType] ?? FALLBACK_VISIBLE_TABS;
    }

    private mapToVisibleTabs(roleBaseAccessOutDto: RoleBaseAccessOutDto,
                             defaultVisibleTabs: TAB_TYPE[]): TAB_TYPE[] {
        const configuredVisibleTabs: TAB_TYPE[] = roleBaseAccessOutDto?.visibleTabs ?? [];
        return configuredVisibleTabs.length > 0 ? configuredVisibleTabs : defaultVisibleTabs;
    }

    private buildCollectionPath(organizationId: string): string {
        return `${ORGANIZATION_COLLECTION}/${organizationId}/${ROLE_BASE_ACCESS_SUB_COLLECTION}`;
    }
}

export class RoleBaseAccessOutDto {
    id: string;
    memberType: MEMBER_TYPE;
    visibleTabs: TAB_TYPE[];
    lastModifiedAt: string;
}
